import Ext from "Ext";
import ScrollUtils from "../../util/ScrollUtils";
import TreeNodeHelper from "./at_tree_node_helper";

/**
 * Abstract selector tree.
 */
const SelectorTree = Ext.extend(Ext.Container, {
    data: [],
    autoEl: "div",
    layout: "table",
    layoutConfig: {
        columns: 1
    },
    cls: "at-selector-tree",
    inactiveCls: "at-selector-tree-inactive",

    /**
     * @cfg {AT.GenericSelectorTreePropertiesController} propertiesController controller used
     * to extract tree item properties
     */
    propertiesController: null,

    /**
     * @cfg {Function} nodeHelperCtor constructor for a {@link AT.TreeNodeHelper} implementation (required).
     */
    nodeHelperCtor: TreeNodeHelper,

    /**
     * {AT.TreeNodeHelper} nodeHelper {@link AT.TreeNodeHelper} implementation.
     */
    nodeHelper: null,

    /**
     * @cfg {Array} itemTooltipMessageParams specifies message to be show for selectorTree item's tooltips on some
     *              specific conditions.
     */
    itemTooltipMessageParams: null,

    initComponent: function() {
        SelectorTree.superclass.initComponent.call(this);

        if ( !this.nodeHelper )
            this.nodeHelper = new this.nodeHelperCtor({
                propertiesController: this.propertiesController,
                tooltipMessageParams: this.itemTooltipMessageParams
            });
        else
            this.nodeHelper.setPropertiesController(this.propertiesController);

        Ext.each(this.createNodes(), function(node) { this.add(node); }, this);
        this.addEvents("change");
    },

    /**
     * Creates the tree nodes based on <code>data</code> property.
     * @type {Array} array of {@link AT.SelectorTreeNode} objects.
     * @private
     */
    createNodes: Ext.emptyFn,

    /**
     * Resets the nodes' states.
     */
    resetNodes: Ext.emptyFn,

    /**
     * @param {Boolean} selectHidden determines if the selection should include hidden items.
     * @returns Selected data items.
     */
    getSelection: Ext.emptyFn,

    /**
     * Set the tree inactive state.
     * @param value true to set inactive, false to set active.
     */
    setInactive: function(value) {
        value = value !== false;
        if (value) {
            this.addClass(this.inactiveCls);
        } else {
            this.removeClass(this.inactiveCls);
        }
    },

    /**
     * Selects all nodes in the tree.
     */
    selectAll: function() {
        this.items.each(function(item) {
            item.select();
        });
        this.onChange();
    },

    /**
     * Deselects all nodes in the tree.
     */
    selectNone: function() {
        this.items.each(function(item) {
            item.select(false);
        });
        this.onChange();
    },

    /**
     * Filters all nodes in the tree.
     * @param {Function} condition condition function.
     * @param {Object} scope condition function scope.
     */
    filter: function(condition, scope) {
        if(typeof this.items != 'undefined')
        this.items.each(function(item) {
            item.filter(condition, scope);
        });
        this.onChange();
    },
    
    onChange: function() {
        this.fireEvent("change", this);
        ScrollUtils.refreshCustomScroll(this.customScroller);
    }
});

export default SelectorTree;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_selector_tree.js